import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-orgs-people
 */
export function getOrgPeople(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/people?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
export function getOrgPeopleLite(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/people/lite?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
export function getOrgWfhLite(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/people/lite-wfh?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
export function getOrgArchivedLite(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/people/lite-archived?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
